import '../scss/styles.scss';
import NavItemVo from './navItemVo';
import HeaderLogosVo from './headerLogosVo';
import Characters from './characters';
import { characterData } from './data/characterData';
import IdleAnimations from './idleAnimations';
import { isiOS, detectDevice } from './utils/device-detection';

(function () {
  // setup character instances
  characterData.forEach((character) => {
    new Characters(character.id, character.vo);
  });

  // Setup VO trggers
  new NavItemVo();
  new HeaderLogosVo();

  // Setup idle logic
  new IdleAnimations();

  // Preloader setup
  const preloader = document.getElementById('preloader');
  if (preloader) {
    window.addEventListener('load', () => {
      // remove the preloader element from dom after 3secs
      setTimeout(() => {
        preloader.remove();

        // target the body dom element and remove the class of 'overflow-hidden'
        document.body.classList.remove('overflow-hidden');
      }, 1500);
    });
  }

  // add device class to body
  document.body.classList.add(detectDevice());

  if (document.getElementById('button-fullscreen') && isiOS()) {
    document.getElementById('button-fullscreen').style.display = 'none';
  }
})();
